import { EntityFields } from '@/entities/utils/types'
import { Document } from './types'
import { DocumentSource } from './enums'

export { DOCUMENT_ID_PREFIX } from '@/const/common'

export const DOCUMENT_FIELD: EntityFields<Document> = {
  ID: 'id',
  NAME: 'name',
  PATH: 'path',
  ASSET_ID: 'asset_id',
  REPOSITORY_ID: 'repository_id',
  SOURCE: 'source',
  TAGS: 'tags',
  FILENAME: 'filename',
  FILE: 'file',
  URL: 'url',
  CREATED_AT: 'created_at',
  CREATED_BY: 'created_by',
  UPDATED_AT: 'updated_at',
  UPDATED_BY: 'updated_by',
}

export const DOCUMENT_DEFAULT_DATA = {
  id: '',
  name: '',
  path: '',
  asset_id: null,
  repository_id: '',
  source: DocumentSource.URL,
  filename: '',
  url: '',
}

export const DOCUMENT_FIELD_LABEL = {
  [DOCUMENT_FIELD.NAME]: 'Document',
  [DOCUMENT_FIELD.PATH]: 'Path',
  [DOCUMENT_FIELD.SOURCE]: 'Source',
  [DOCUMENT_FIELD.ASSET_ID]: 'Asset',
  [DOCUMENT_FIELD.TAGS]: 'Tags',
  [DOCUMENT_FIELD.FILENAME]: 'File',
  [DOCUMENT_FIELD.URL]: 'Url',
  [DOCUMENT_FIELD.CREATED_AT]: 'Created at',
  [DOCUMENT_FIELD.UPDATED_AT]: 'Updated at',
}

export const DOCUMENT_ACTION_LABEL: Record<DocumentSource, string> = {
  [DocumentSource.GOOGLE_DRIVE]: 'Google Drive',
  [DocumentSource.DROPBOX]: 'Dropbox',
  [DocumentSource.ONE_DRIVE]: 'OneDrive',
  [DocumentSource.URL]: 'Other Link',
  [DocumentSource.ALLPOSIT]: 'Upload File',
  [DocumentSource.ALLPOSIT_THUMBNAIL]: 'Upload Thumbnail',
}

export const DOCUMENT_SOURCE_LABEL: Record<DocumentSource, string> = {
  [DocumentSource.GOOGLE_DRIVE]: 'Google Drive',
  [DocumentSource.DROPBOX]: 'Dropbox',
  [DocumentSource.ONE_DRIVE]: 'OneDrive',
  [DocumentSource.URL]: 'External Link',
  [DocumentSource.ALLPOSIT]: 'File',
  [DocumentSource.ALLPOSIT_THUMBNAIL]: 'Thumbnail',
}

export const DOCUMENT_SOURCE_ICON: Record<DocumentSource, string> = {
  [DocumentSource.GOOGLE_DRIVE]: 'document-google-drive.svg',
  [DocumentSource.DROPBOX]: 'document-dropbox.svg',
  [DocumentSource.ONE_DRIVE]: 'document-microsoft-onedrive.svg',
  [DocumentSource.URL]: 'document-url.svg',
  [DocumentSource.ALLPOSIT]: 'document-allposit.svg',
  [DocumentSource.ALLPOSIT_THUMBNAIL]: 'document-allposit-thumb.svg',
}
